import Joi from "joi";

import { ProductDescriptionsEntity } from "~/constants/forms";
import { productDescription } from "./commonSchema";

export default Joi.object({
  [ProductDescriptionsEntity.PRODUCT_DESCRIPTION]: productDescription,
});
